import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toggleAccDropDownList } from "../../../REDUX/NavbarDropDownToggle/navBarDropToggle";
import {
  toggleSignUpStatus,
  toggleLoginStatus,
} from "../../../REDUX/RegistrationModalToggle/toggleModal";
import { profileDropDownDetails } from "../../Products/ProduArrs";
import NavDropDownPop from "./NavDropDownPop";

const NavAuthState = () => {
  const { accDropDownList } = useSelector((state) => state.DropDownNav);

  const { currentUser } = useSelector((state) => state.User);
  const dispatch = useDispatch();

  function showLogin() {
    dispatch(toggleLoginStatus());
  }
  function signUp() {
    dispatch(toggleSignUpStatus());
  }

  console.log(currentUser);
  return (
    <div>
      {currentUser ? (
        <ul className="flex items-center space-x-6 cursor-pointer">
          <Link to="Dashboard/my_notification">
            <li className="text-[#007BFF] text-lg">
              <i className="bi bi-bell"></i>
            </li>
          </Link>

          <li className="text-[#007BFF] text-lg">
            <div className="relative">
              <div onClick={() => dispatch(toggleAccDropDownList())}>
                <i className="bi bi-person-circle text-xl"></i>
                <i className="bi bi-caret-down-fill text-xs text-black absolute bottom-0"></i>
              </div>
              {/* show drop down when click */}
              {/* profile list drop down shown here when button is click */}
              <div className="absolute right-44 top-14 z-20">
                {accDropDownList ? (
                  <NavDropDownPop
                    profileDropDownDetails={profileDropDownDetails}
                  />
                ) : null}
              </div>
            </div>
          </li>
        </ul>
      ) : (
        <ul className="flex items-center space-x-6 cursor-pointer">
          <li onClick={showLogin} className="text-[#272222]">
            Login
          </li>
          <div className=" h-6 border-black border"></div>
          <li onClick={signUp} className="text-[#272222]">
            Register
          </li>
        </ul>
      )}

      {/* </ul> */}
    </div>
  );
};

export default NavAuthState;
